<template>
    <div
        v-if="groupMembers.length"
        class="flex items-center gap-2 bg-[#EBECEC] p-2 rounded-lg mt-4 overflow-x-auto"
        id="groupMemberContainer"
    >
        <template v-for="(contact, index) in groupMembers" :key="index">
            <div v-if="contact.first_name">
                <ContactNameIcon
                    :badgeClass="`${contact.badge} h-[3rem] w-[3rem]`"
                    :nameText="contact.first_name"
                    :nameLetter="contact.first_name.charAt(0)"
                    :isCancelAble="true"
                    :lastNameLetter="contact.last_name ? contact.last_name.charAt(0) : ''"
                    nameTextClass="text-sm mt-2"
                    class="justify-center !flex flex-col min-w-[4rem]"
                    @handleClick="(state) => emits('handleCancel', state, contact)"
                />
            </div>
        </template>
    </div>
</template>

<script setup>
import ContactNameIcon from "@/components/contacts/ContactNameIcon.vue";

const emits = defineEmits(["handleCancel"]);

const props = defineProps({
    groupMembers: {
        type: Array,
        default: [],
    },
});
</script>
